// extracted by mini-css-extract-plugin
export default {"container":"Paginado_container__blWGF","ul":"Paginado_ul__vRRCo","li":"Paginado_li__MIsHW","libtn":"Paginado_libtn__BWcTE","current":"Paginado_current__ZZnLf"};